// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Csat$ReactHooksTemplate = require("./csat.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

function CsatEditor(props) {
  var onCsatChange = props.onCsatChange;
  var csat = props.csat;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Switch Order",
                                    className: "text-darkcharcoal text-sm font-medium"
                                  }),
                              JsxRuntime.jsxs("label", {
                                    children: [
                                      JsxRuntime.jsx("input", {
                                            checked: !Csat$ReactHooksTemplate.negativeToPositive(csat),
                                            type: "checkbox",
                                            onChange: (function (param) {
                                                Curry._1(onCsatChange, Csat$ReactHooksTemplate.toggleNegativeToPositive(csat));
                                              })
                                          }),
                                      JsxRuntime.jsx("span", {
                                            className: "slider round"
                                          })
                                    ],
                                    className: "switch"
                                  })
                            ],
                            className: "flex justify-between"
                          }),
                      className: "mb-4 pb-4 border-b border-gray-300"
                    })
              ]
            });
}

var make = CsatEditor;

exports.make = make;
/* react/jsx-runtime Not a pure module */
